define([
  'jquery',
  'jquery.print-preview',
], function($) {

  $.shareServices = {
    amazonuniversalregistry: {
      name: 'Amazon Universal Registry',
      url: 'https://www.amazon.com/registry/add?t={TEXT}&u={URL}',
      width: 1000,
      height: 640,
      background: '#F7AD29',
      color: '#fff',
    },
    amazonuswishlist: {
      name: 'Amazon Wishlist',
      url: 'https://www.amazon.com/wishlist/add?t={TEXT}&u={URL}',
      width: 1000,
      height: 640,
      background: '#FC9A18',
      color: '#fff'
    },
    aollifestream: {
      name: 'AOL Lifestream',
      url: 'http://lifestream.aol.com/share/?url={URL}&title={TEXT}&description={DESC}',
      width: 580,
      height: 440,
      background: '#8DB822',
      color: '#fff',
    },
    aolmail: {
      name: 'AOL Mail',
      url: 'https://mail.aol.com/webmail-std/en-us/composemessage?to=&subject={TEXT}&body={URL}',
      width: 600,
      height: 500,
      background: '#262626',
      color: '#fff',
    },
    arto: {
      name: 'Arto',
      url: 'http://www.arto.com/section/linkshare/default.aspx?lu={URL}&ln={TEXT}',
      width: 1000,
      height: 770,
      background: '#8DB822',
      color: '#fff',
    },
    bitly: {
      name: 'Bitly',
      url: 'https://bitly.com/a/bitmarklet?u={URL}',
      width: 1160,
      height: 500,
      background: '#EE6023',
      color: '#fff',
    },
    bloggerpost: {
      name: 'Blogger',
      url: 'https://www.blogger.com/blog-this.g?t&u={URL}&n={TEXT}',
      width: 750,
      height: 700,
      background: '#F79638',
      color: '#fff',
    },
    boxnet: {
      name: 'Box',
      url: 'https://www.box.com/api/1.0/import?import_as=link&url={URL}&name={TEXT}',
      width: 500,
      height: 500,
      background: '#2F88B1',
      color: '#fff',
    },
    buffer: {
      name: 'Buffer',
      url: 'http://bufferapp.com/add?text={TEXT}&url={URL}',
      width: 890,
      height: 532,
      background: '#242424',
      color: '#fff',
      fetch: 'https://api.bufferapp.com/1/links/shares.json?url={URL}',
      parse: function(data) {
        return parseInt(data.shares);
      },
      priority: 89,
    },
    delicious: {
      name: 'Delicious',
      url: 'http://del.icio.us/post?url={URL}&title={TEXT}&notes={DESC}',
      width: 550,
      height: 588,
      background: '#3399ff',
      color: '#fff',
      priority: 85,
    },
    digg: {
      name: 'Digg',
      url: 'http://digg.com/submit?url={URL}&title={TEXT}',
      width: 1080,
      height: 670,
      background: '#0093CC',
      color: '#fff',
      priority: 86,
    },
    diigo: {
      name: 'Diigo',
      url: 'https://www.diigo.com/post?url={URL}&title={TEXT}&description={DESC}',
      width: 625,
      height: 660,
      background: '#4DA2E4',
      color: '#fff',
    },
    diigolet: {
      name: 'Diigolet',
      width: 600,
      height: 500,
      background: '#4DA2E4',
      color: '#fff',
      javascript: function() {
        s=document.createElement("script");
        s.type="text/javascript";
        s.src="https://www.diigo.com/javascripts/webtoolbar/diigolet_b_h_b.js";
        document.body.appendChild(s);
      },
    },
    email: {
      name: 'Email',
      url: 'mailto:?subject={TEXT}&body={DESC}%20{URL}{PROMO}',
      width: 600,
      height: 500,
      background: '#aaa',
      color: '#fff',
      priority: 99,
    },
    evernote: {
      name: 'Evernote',
      url: 'http://www.evernote.com/clip.action?url={URL}&title={TEXT}',
      width: 960,
      height: 533,
      background: '#6fb536',
      color: '#fff',
      priority: 85,
    },
    facebook: {
      name: 'Facebook',
      url: 'http://www.facebook.com/sharer.php?u={URL}',
      width: 600,
      height: 600,
      background: '#3b5998',
      color: '#fff',
      //fetch: '//api.facebook.com/method/links.getStats?urls={URL}&format=json',
      fetch: '//graph.facebook.com/?id={URL}',
      parse: function(data) {
        //return parseInt(data[0]['share_count']);
        return parseInt(data['share']['share_count']);
      },
      priority: 100,
    },
    facebooklike: {
      name: 'Facebook Like',
      url: 'https://sumome.com/apps/share/facebook-like?href={URL}',
      width: 600,
      height: 300,
      background: '#5a739d',
      color: '#fff',
      fetch: '//api.facebook.com/method/links.getStats?urls={URL}&format=json',
      parse: function(data) {
        return parseInt(data[0]['like_count']);
      },
      priority: 95,
    },
    facebooksend: {
      name: 'Facebook Send',
      url: 'https://www.facebook.com/dialog/send?app_id=859406404089021&link={URL}&redirect_uri=https%3a%2f%sumome.com%2fapps%2fshare%2fthanks&display=popup',
      width: 600,
      height: 500,
      background: '#3b5998',
      color: '#fff'
    },
    fancy: {
      name: 'Fancy',
      width: 600,
      height: 500,
      background: '#494E57',
      color: '#fff',
      javascript: function() {
        // Based on Fancy it Bookmarklet
        // https://fancy.com/about/add-to-fancy
        thefancy_username='';
        var script_id='thefancy_tagger_bookmarklet_helper_js',
          s=document.getElementById(script_id),
          can_continue=true;

        if(s){
          var t=window;
          try{
            if(t.thefancy_bookmarklet){
              t.thefancy_bookmarklet.tagger.cleanListeners();
              s.parentNode.removeChild(s)
            }else{
              can_continue=false;
            }
          }catch(e5){
            can_continue=false
          }
        };

        if(can_continue){
          _my_script=document.createElement('SCRIPT');
          _my_script.type='text/javascript';
          _my_script.id = script_id;
          _my_script.src=location.protocol+'//fancy.com/bookmarklet/fancy_tagger.js?x='+(Math.random());
          document.getElementsByTagName('head')[0].appendChild(_my_script);
        }
      },
    },
    flipboard: {
      name: 'Flipboard',
      url: 'https://share.flipboard.com/bookmarklet/popout?v=2&title={TEXT}&url={URL}',
      width: 600,
      height: 500,
      background: '#CC0713',
      color: '#fff',
    },
    friendfeed: {
      name: 'FriendFeed',
      url: 'http://www.friendfeed.com/share?url={URL}&title={TEXT}',
      width: 800,
      height: 550,
      background: '#87a9d9',
      color: '#fff'
    },
    googlebookmarks: {
      name: 'Google Bookmarks',
      url: 'https://www.google.com/bookmarks/mark?op=edit&output=popup&bkmk={URL}&title={TEXT}&annotation={DESC}',
      width: 600,
      height: 500,
      background: '#4A8CF6',
      color: '#fff',
    },
    googlemail: {
      name: 'Gmail',
      url: 'https://mail.google.com/mail/u/0/?view=cm&fs=1&to&su={TEXT}&body={URL}&ui=2&tf=1',
      width: 600,
      height: 500,
      background: '#E04C40',
      color: '#fff',
    },
    hootsuite: {
      name: 'Hootsuite',
      url: 'https://hootsuite.com/hootlet/load?address={URL}&title={TEXT}',
      width: 750,
      height: 650,
      background: '#000',
      color: '#fff',
    },
    houzz: {
      name: 'Houzz',
      width: 600,
      height: 500,
      background: '#7AC143',
      color: '#fff',
      javascript: function() {
        // Based on the Houzz Bookmarklet
        // http://www.houzz.com/bookmarklet/mode=non_chrome
        function addToQueryString(url, key, value) {
          var query = url.indexOf('?');
          var anchor = url.indexOf('#');
          if (query == url.length - 1) {
            // Strip any ? on the end of the URL
            url = url.substring(0, query);
            query = -1;
          }
          return (anchor > 0 ? url.substring(0, anchor) : url)
            + (query > 0 ? "&" + key + "=" + value : "?" + key + "=" + value)
            + (anchor > 0 ? url.substring(anchor) : "");
        }

        var ss = document.createElement('link');
        ss.rel = 'stylesheet';
        ss.href = addToQueryString('//www.houzz.com/res/2125/css/style?f=clipper', 'cb', Math.floor(Math.random()*1000000));
        document.getElementsByTagName('head')[0].appendChild(ss);

        var js = document.createElement('script');
        js.type = 'text/javascript';
        js.src = addToQueryString('//www.houzz.com/js/script?f=clipper&v=2125&s=101&l=en-US&d=1&m=1', 'cb', Math.floor(Math.random()*1000000));
        document.body.appendChild(js);
      },
    },
    instapaper: {
      name: 'Instapaper',
      url: 'http://www.instapaper.com/hello2?url={URL}&title={TEXT}&description={DESC}',
      width: 475,
      height: 200,
      background: '#464646',
      color: '#000'
    },
    kaboodle: {
      name: 'Kaboodle',
      width: 600,
      height: 500,
      background: '#B9212A',
      color: '#fff',
      javascript: function() {
        var _mg56v='0.3';
        var d=document;
        var s;

        try{
          s=d.standardCreateElement('script');
        }catch(e){}

        if(typeof(s)!='object')
          s=d.createElement('script');

        try{
          s.type='text/javascript';
          s.src='http://www.kaboodle.com/zg/g.js';
          s.id='c_grab_js';
          d.getElementsByTagName('head')[0].appendChild(s);
        }catch(e){
          window.location ='http://www.kaboodle.com/za/selectpage?p_pop=false&pa=url&u='+window.location;
        }
      }
    },
    kik: {
      name: 'Kik',
      url: 'http://share-api.kik.com/share.do?url={URL}&title={TEXT}',
      width: 600,
      height: 550,
      background: '#8CC04F',
      color: '#fff'
    },
    lineapp: {
      // http://media.line.me/howto/en/
      name: 'Line',
      url: 'http://line.me/R/msg/text/?{TEXT}%20-%20{URL}',
      width: 600,
      height: 500,
      background: '#01C312',
      color: '#fff'
    },
    linkedin: {
      name: 'LinkedIn',
      url: 'http://www.linkedin.com/shareArticle?mini=true&url={URL}&title={TEXT}&summary={DESC}',
      width: 615,
      height: 495,
      background: '#007bb6',
      color: '#fff',
      method: 'linkedin',
      // fetch: 'https://www.linkedin.com/countserv/count/share?format=jsonp&url={URL}',
      // parse: function(data) {
      //   return parseInt(data.count);
      // },
      priority: 91,
    },
    meneame: {
      name: 'Menéame',
      url: 'https://www.meneame.net/submit.php?url={URL}',
      width: 600,
      height: 500,
      background: '#FC6320',
      color: '#fff',
    },
    microsoftonenote: {
      name: 'Microsoft OneNote',
      url: 'https://www.onenote.com/clipper/save?sourceUrl={URL}&title={TEXT}&notes={DESC}',
      width: 800,
      height: 660,
      background: '#80397B',
      color: '#fff',
    },
    misterwong: {
      name: 'Mister Wong',
      url: 'http://www.mister-wong.com/index.php?action=addurl&bm_url={URL}&bm_description={TEXT}',
      width: 1000,
      height: 560,
      background: '#AB0414',
      color: '#fff',
    },
    misterwongcn: {
      name: 'Mister Wong CN',
      url: 'http://www.mister-wong.cn/index.php?action=addurl&bm_url={URL}&bm_description={TEXT}',
      width: 1000,
      height: 560,
      background: '#AB0414',
      color: '#fff',
    },
    misterwonges: {
      name: 'Mister Wong ES',
      url: 'http://www.mister-wong.es/index.php?action=addurl&bm_url={URL}&bm_description={TEXT}',
      width: 1000,
      height: 560,
      background: '#AB0414',
      color: '#fff',
    },
    misterwongfr: {
      name: 'Mister Wong FR',
      url: 'http://www.mister-wong.fr/index.php?action=addurl&bm_url={URL}&bm_description={TEXT}',
      width: 1000,
      height: 560,
      background: '#AB0414',
      color: '#fff',
    },
    misterwongru: {
      name: 'Mister Wong RU',
      url: 'http://www.mister-wong.RU/index.php?action=addurl&bm_url={URL}&bm_description={TEXT}',
      width: 1000,
      height: 560,
      background: '#AB0414',
      color: '#fff',
    },
    newsvine: {
      name: 'Newsvine',
      url: 'http://www.newsvine.com/_tools/seed&save?u={URL}&h={TEXT}',
      width: 500,
      height: 700,
      background: '#11660C',
      color: '#fff',
    },
    odnoklassniki: {
      name: 'Odnoklassniki',
      url: 'http://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl={URL}',
      width: 540,
      height: 395,
      background: '#F38230',
      color: '#fff',
      //fetch: '//ok.ru/dk?st.cmd=extLike&uid=odklcnt0&ref={URL}',
      //method: 'jsonproxy',
      //parse: function(data) {
      //  return parseInt(data.data.match(/^ODKL\.updateCount\(\'odklcnt0\',\'(\d+)\'\);$/)[1]);
      //}
    },
    outlook: {
      name: 'Outlook',
      url: 'https://mail.live.com/secure/start?action=compose&to=&subject={TEXT}&body={URL}',
      width: 600,
      height: 500,
      background: '#1172C6',
      color: '#fff',
    },
    pinboardin: {
      name: 'Pinboard',
      url: 'https://pinboard.in/add?next=same&url={URL}&description={DESC}&title={TEXT}',
      width: 600,
      height: 500,
      background: '#214CF4',
      color: '#fff',
    },
    pinterest: {
      name: 'Pinterest',
      url: 'http://pinterest.com/pin/create/button/?url={URL}&description={TEXT}&media={IMAGE}',
      width: 765,
      height: 320,
      background: '#cb2027',
      color: '#fff',
      fetch: '//widgets.pinterest.com/v1/urls/count.json?callback=?&source=6&url={URL}',
      parse: function(data) {
        return parseInt(data.count);
      },
      javascript: function(sumoUrl, msg, url, text, desc, image, cb) {

        var selectPinImage = function(cb, url, prepend, append, hidden, within, elements) {
          var defaultTitle = '';

          var m = {
            k: "PIN_" + (new Date).getTime(),
            me: /\/\/assets\.pinterest\.com\/js\/pinmarklet\.js/,
            //grid: "https://assets.pinterest.com/ext/grid.html",
            grid: sumoUrl + "/apps/share/pinterest-grid",
            maxWait: 5e3,
            //maxWait: 10000,
            quality: 30,
            xv: "data-pinterest-extension-installed",
            log: "https://log.pinterest.com/",
            hazPinningNow: "data-pinterest-pinmarklet-rendered",
            pattern: {
                instagram: {
                    page: /^https?:\/\/(.*?\.|)instagram\.com\//,
                    url: /^https?:\/\/(.*?\.|)instagram\.com\/p\//
                },
                amazon: {
                    media: /^https?:\/\/(.*?\.|)images-amazon\.com\/images\//,
                    page: /^https?:\/\/(.*?\.|)amazon\.com\//
                },
                pinterest: {
                    page: /^https?:\/\/(.*?\.|)pinterest\.com\//
                },
                facebook: {
                    page: /^https?:\/\/([a-zA-Z0-9]*\.|)facebook\.com\//
                },
                craigslist: {
                    page: /^https?:\/\/(.*?\.|)craigslist\.org\//
                },
                itunes: {
                    page: /^https?:\/\/itunes\.apple\.com\//
                },
                youtube: {
                    iframe: /^https?:\/\/www\.youtube\.com\/embed/,
                    media: /^https?:\/\/(.*?\.|)ytimg\.com\/(vi|li)\//,
                    page: /^https?:\/\/(.*?\.|)youtube\.com\//
                },
                flickr: {
                    media: /^https?:\/\/(.*?)\.staticflickr\.com\//,
                    page: /^https?:\/\/www\.flickr\.com\//
                },
                "500px": {
                    media: /^https?:\/\/(.*?)\.500px\.org\//
                },
                vimeo: {
                    iframe: /^https?:\/\/player\.vimeo\.com\/video\//,
                    media: /^https?:\/\/i\.vimeocdn\.com\/video\//,
                    page: /^https?:\/\/vimeo\.com\//
                },
                google: {
                    page: /^https?:\/\/www\.google\.com\/search(.*&tbm=isch.*)/
                },
                twitter: {
                    page: /^https?:\/\/twitter\.com\//
                },
                wikipedia: {
                    page: /^https?:\/\/(.*?\.|)wikipedia\.org\//
                }
            },
            validConfigParam: ["debug", "noCancel", "noHeader", "pinMethod", "render", "share", "quiet", "quality", "pinbox", "via", "xuid", "edu", "guid"],
            validImageFileType: {
                gif: 1,
                jpg: 1,
                jpeg: 1,
                png: 1,
                webp: 1
            },
            invalidImageFileType: {
                svg: 1
            },
            imgLimitMin: 119,
            imgLimitFloor: 79,
            imgLimitHorz: 3,
            thumbCellSize: 236,
            thumbCellMargin: 14,
            tag: {
                link: ["rel", "href"],
                meta: ["name", "content", "property", "http-equiv", "content-language"],
                a: ["data-pin-href", "data-pin-id"],
                iframe: ["src"],
                img: ["src", "title", "alt", "naturalHeight", "naturalWidth", "nopin", "data-pin-nopin", "data-pin-id", "data-pin-media", "data-pin-url", "data-pin-description", "usemap"]
            },
            cdn: {
                "https:": "https://s-passets.pinimg.com",
                "http:": "http://passets.pinterest.com"
            },
            msg: msg,
            hashList: [/efa3a2deb839/, /20c46b653b00/, /9e2089d8b8f2/, /820a6e7baa0f/, /293aa4f9b3d0/, /1529ad2b2cc8/, /8de5d416e5d2/, /8c2d5961f7af/, /540b2374abf1/, /415215dcadbf/, /dbafdf055617/, /871de03c9980/, /85ae87da6618/, /1d1d5ffa1d50/, /1847807c0ea1/, /08fb2eb6424d/, /a32353817e45/, /71c1f4783e6d/, /79f57d83d54a/, /eefa602a72ed/, /32aa39d04eb4/, /25f7c9982cea/]
          };

          var d = window[m.k] = {
              w: window,    // window
              d: document,  // document
              a: m,         // JSON vars object
              s: {},
              f: function() {
                  return {
                      callback: [],
                      sha: function(a) {
                          function b(a) {
                              for (var b = Array(a.length >> 2), c = 0; c < b.length; c++)
                                  b[c] = 0;
                              for (c = 0; c < 8 * a.length; c += 8)
                                  b[c >> 5] |= (255 & a.charCodeAt(c / 8)) << 24 - c % 32;
                              return b
                          }
                          function c(a) {
                              for (var b = "", c = 0; c < 32 * a.length; c += 8)
                                  b += String.fromCharCode(a[c >> 5] >>> 24 - c % 32 & 255);
                              return b
                          }
                          function d(a, b) {
                              var c = (65535 & a) + (65535 & b)
                                , d = (a >> 16) + (b >> 16) + (c >> 16);
                              return d << 16 | 65535 & c
                          }
                          function e(a, b) {
                              return a << b | a >>> 32 - b
                          }
                          function f(a, b) {
                              a[b >> 5] |= 128 << 24 - b % 32,
                              a[(b + 64 >> 9 << 4) + 15] = b;
                              for (var c = Array(80), f = 1732584193, i = -271733879, j = -1732584194, k = 271733878, l = -1009589776, m = 0; m < a.length; m += 16) {
                                  for (var n = f, o = i, p = j, q = k, r = l, s = 0; s < 80; s++) {
                                      s < 16 ? c[s] = a[m + s] : c[s] = e(c[s - 3] ^ c[s - 8] ^ c[s - 14] ^ c[s - 16], 1);
                                      var t = d(d(e(f, 5), g(s, i, j, k)), d(d(l, c[s]), h(s)));
                                      l = k,
                                      k = j,
                                      j = e(i, 30),
                                      i = f,
                                      f = t
                                  }
                                  f = d(f, n),
                                  i = d(i, o),
                                  j = d(j, p),
                                  k = d(k, q),
                                  l = d(l, r)
                              }
                              return Array(f, i, j, k, l)
                          }
                          function g(a, b, c, d) {
                              return a < 20 ? b & c | ~b & d : a < 40 ? b ^ c ^ d : a < 60 ? b & c | b & d | c & d : b ^ c ^ d
                          }
                          function h(a) {
                              return a < 20 ? 1518500249 : a < 40 ? 1859775393 : a < 60 ? -1894007588 : -899497514
                          }
                          function i(a) {
                              return c(f(b(a), 8 * a.length))
                          }
                          function j(a) {
                              for (var b, c = "0123456789abcdef", d = "", e = 0; e < a.length; e++)
                                  b = a.charCodeAt(e),
                                  d = d + c.charAt(b >>> 4 & 15) + c.charAt(15 & b);
                              return d
                          }
                          return j(i(a))
                      },
                      get: function(a, b) {
                          var c = null ;
                          return c = "undefined" !== typeof a[b] ? a[b] : a.getAttribute(b)
                      },
                      set: function(a, b, c) {
                          "string" === typeof a[b] ? a[b] = c : a.setAttribute(b, c)
                      },
                      getEl: function(a) {
                          var b = null ;
                          return b = a.target ? 3 === a.target.nodeType ? a.target.parentNode : a.target : a.srcElement
                      },
                      parse: function(a, b) {
                          var c, d, e, f, g, h;
                          if (h = {},
                          c = a.split("#")[0].split("?"),
                          c[1])
                              for (d = c[1].split("&"),
                              f = 0,
                              g = d.length; f < g; f += 1)
                                  e = d[f].split("="),
                                  2 === e.length && b[e[0]] && (h[e[0]] = e[1]);
                          return h
                      },
                      make: function(a) {
                          var b, c, e, f = !1;
                          for (b in a)
                              if (a[b].hasOwnProperty) {
                                  f = d.d.createElement(b);
                                  for (c in a[b])
                                      if (a[b][c] && a[b][c].hasOwnProperty)
                                          if ("string" === typeof a[b][c])
                                              d.f.set(f, c, a[b][c]);
                                          else if ("style" === c)
                                              for (e in a[b][c])
                                                  f.style.setProperty ? f.style.setProperty(e, a[b][c][e], "important") : f.style[e] = a[b][c][e];
                                  break
                              }
                          return f
                      },
                      kill: function(a) {
                          "string" === typeof a && (a = d.d.getElementById(a)),
                          a && a.parentNode && a.parentNode.removeChild(a)
                      },
                      call: function(a, b) {
                          var c, e, f = "?";
                          d.v.nextCallback || (d.v.nextCallback = 0),
                          c = d.v.nextCallback,
                          d.v.nextCallback = d.v.nextCallback + 1,
                          e = d.a.k + ".f.callback[" + c + "]",
                          d.f.callback[c] = function(a) {
                              b(a, c),
                              d.f.kill(e),
                              d.v.callbackLoadingCount = d.v.callbackLoadingCount - 1
                          }
                          ,
                          a.match(/\?/) && (f = "&"),
                          d.d.b.appendChild(d.f.make({
                              SCRIPT: {
                                  id: e,
                                  type: "text/javascript",
                                  charset: "utf-8",
                                  src: a + f + "callback=" + e
                              }
                          })),
                          d.v.callbackLoadingCount = d.v.callbackLoadingCount + 1,
                          undefined
                      },
                      listen: function(a, b, c, e) {
                          if ('undefined' !== typeof d.w['sumomeSharePinterestEvent']) {
                            if ("undefined" !== typeof a.removeEventListener) {
                              console.log('[jquery.share] removing event listener...');
                              a.removeEventListener(b, d.w.sumomeSharePinterestEvent, !1);
                            }
                            if ("undefined" !== typeof a.detachEvent) {
                              console.log('[jquery.share] detaching event...');
                              a.detachEvent("on" + b, d.w.sumomeSharePinterestEvent);
                            }
                          }

                          e ? "undefined" !== typeof a.removeEventListener ? a.removeEventListener(b, c, !1) : "undefined" !== typeof a.detachEvent && a.detachEvent("on" + b, c) : "undefined" !== typeof d.w.addEventListener ? a.addEventListener(b, c, !1) : "undefined" !== typeof d.w.attachEvent && a.attachEvent("on" + b, c)

                          d.w.sumomeSharePinterestEvent = c;

                          // if ("undefined" !== typeof d.w.addEventListener) {
                          //   console.log('[jquery.share] adding event listener...');
                          //   a.addEventListener(b, c, !1);
                          // }
                          // if ("undefined" !== typeof d.w.attachEvent) {
                          //   console.log('[jquery.share] attaching event...');
                          //   a.attachEvent("on" + b, c);
                          // }
                      },
                      debug: function(a) {
                      },
                      getConfig: function() {
                          var a = d.d.getElementsByTagName("SCRIPT")
                            , b = a.length
                            , c = 0
                            , e = 0
                            , f = d.a.validConfigParam.length
                            , g = null
                            , h = ""
                            , i = function(a) {
                              d.w.setTimeout(function() {
                                  d.f.kill(a)
                              }, 10)
                          }
                          ;
                          for (c = 0; c < b; c += 1)
                              if (a[c].src.match(d.a.me)) {
                                  for (e = 0; e < f; e += 1)
                                      h = d.a.validConfigParam[e],
                                      g = a[c].getAttribute(h),
                                      g && (d.v.config[h] = g);
                                  i(a[c]);
                                  break
                              }
                      },
                      getSelection: function() {
                          return ("" + (d.w.getSelection ? d.w.getSelection() : d.d.getSelection ? d.d.getSelection() : d.d.selection.createRange().text)).replace(/(^\s+|\s+$)/g, "")
                      },
                      getDim: function(a) {
                          var b, c;
                          return b = 0,
                          c = 0,
                          "number" === typeof a.naturalHeight ? b = a.naturalHeight : "number" === typeof a.height && (b = a.height),
                          "number" === typeof a.naturalWidth ? c = a.naturalWidth : "number" === typeof a.width && (c = a.width),
                          undefined,
                          {
                              h: b,
                              w: c
                          }
                      },
                      check: {
                          fileType: function(a) {
                              var b, c;
                              return b = !0,
                              a.src && (c = a.src.split("#")[0].split("?")[0].split(".").pop(),
                              d.a.invalidImageFileType[c] && (b = !1,
                              undefined)),
                              b
                          },
                          visibility: function(a) {
                              var b, c, e;
                              for (c = a.parentNode,
                              b = !0; c && "HTML" !== c.tagName; ) {
                                  if (c.currentStyle ? ("none" === c.currentStyle.display || "hidden" === c.currentStyle.visibility) && (b = !1) : d.w.getComputedStyle && ("none" === d.w.getComputedStyle(a).getPropertyValue("display") || "hidden" === d.w.getComputedStyle(a).getPropertyValue("visibility")) && (b = !1),
                                  b === !1) {
                                      e = a.src + ": is invisible";
                                      break
                                  }
                                  c = c.parentNode
                              }
                              return e && undefined,
                              b
                          },
                          noPin: function(a) {
                              var b, c;
                              return b = !0,
                              d.f.get(a, "data-pin-nopin") && (b = !1,
                              c = a.src + ": data-pin-nopin=true"),
                              d.f.get(a, "nopin") && (b = !1,
                              c = a.src + ": nopin=nopin",
                              undefined),
                              c && undefined,
                              b
                          },
                          size: function(a) {
                              var b, c, e;
                              return b = !1,
                              e = d.f.getDim(a),
                              e.h > d.a.imgLimitFloor && e.w > d.a.imgLimitFloor ? e.h > d.a.imgLimitMin || e.w > d.a.imgLimitMin ? e.w < e.h * d.a.imgLimitHorz ? b = !0 : c = a.src + " too wide" : c = a.src + " one dimension <= " + d.a.imgLimitMin : c = a.src + " one dimension <= " + d.a.imgLimitFloor,
                              c && undefined,
                              b
                          },
                          dupe: function(a) {
                              var b = a;
                              "object" === typeof a && (b = a.src);
                              var c = !0;
                              return d.v.src[b] ? (undefined,
                              c = !1) : d.v.src[b] = !0,
                              c
                          },
                          source: function(a, b) {
                              var c, e, f;
                              return c = !1,
                              f = "string" === typeof a ? a : a.src || a.href,
                              f && f.match(/^http/) && (f.match(/File:/) || (b ? (e = f.split("#")[0].split("?")[0].split(".").pop(),
                              d.a.validImageFileType[e] && (c = !0)) : c = !0)),
                              c === !0 && undefined,
                              c
                          },
                          domain: function(a) {
                              var b, c, e, f, g;
                              if (g = a,
                              "object" === typeof a && (g = a.src),
                              f = g.split("/")[2],
                              e = !0,
                              "undefined" === typeof d.v.srcDomain[f]) {
                                  for (var c = d.f.sha(f), b = 0, h = d.a.hashList.length; b < h; b += 1)
                                      if (c.match(d.a.hashList[b])) {
                                          undefined,
                                          undefined,
                                          e = !1;
                                          break
                                      }
                                  d.v.srcDomain[f] = {
                                      bad: e
                                  }
                              } else
                                  e = d.v.srcDomain[f].bad;
                              return e
                          }
                      },
                      tag: {
                          img: function(a) {
                              var b, c;
                              b = !0;
                              for (c in d.f.check)
                                  if (!d.f.check[c](a)) {
                                      b = !1;
                                      break
                                  }
                              return b
                          },
                          iframe: function(a) {
                              var b, c;
                              if (a.src.match(d.a.pattern.instagram.url) && (c = a.src.split("embed"),
                              c[1] && (b = "https://api.instagram.com/oembed?url=" + encodeURIComponent(c[0]),
                              d.f.call(b, d.f.handlers.instagram))),
                              a.src.match(d.a.pattern.youtube.iframe)) {
                                  var c = a.src.split("#")[0].split("?")[0].split("/")[4];
                                  c && (undefined,
                                  b = {
                                      media: "http://i.ytimg.com/vi/" + c + "/hqdefault.jpg",
                                      set: {
                                          description: d.d.title,
                                          url: "http://www.youtube.com/watch?v=" + c,
                                          isVideo: !0,
                                          attrib: "youtube"
                                      }
                                  },
                                  d.f.loadImg(b))
                              }
                              a.src.match(d.a.pattern.vimeo.iframe) && (c = function(c) {
                                  c.thumbnail_url && (undefined,
                                  b = {
                                      media: c.thumbnail_url.split("_")[0] + ".jpg",
                                      set: {
                                          url: "https://vimeo.com/" + c.video_id,
                                          description: c.title,
                                          isVideo: !0,
                                          attrib: "vimeo"
                                      }
                                  },
                                  d.f.loadImg(b))
                              }
                              ,
                              b = "https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(a.src),
                              d.f.call(b, c))
                          },
                          a: function(a) {
                              var b, c, e, f;
                              c = d.f.get(a, "data-pin-href"),
                              c && (e = d.f.parse(c, {
                                  url: !0,
                                  media: !0,
                                  description: !0
                              }),
                              e.media && (undefined,
                              b = {
                                  media: decodeURIComponent(e.media),
                                  set: {
                                      pinItButton: !0,
                                      url: decodeURIComponent(e.url) || void 0,
                                      description: decodeURIComponent(e.description) || void 0
                                  }
                              },
                              f = d.f.get(a, "data-pin-id"),
                              f && (b.set.dataPinId = f),
                              d.f.loadImg(b),
                              d.v.hazLoggedPinItButton || (d.v.hazLoggedPinItButton = !0,
                              undefined)))
                          },
                          link: function(a) {
                              var b, c;
                              b = a.rel,
                              c = a.href,
                              b && c && (b = b.toLowerCase(),
                              "canonical" === b && (undefined,
                              d.v.canonicalUrl || (d.v.canonicalUrl = c)),
                              ("icon" === b || "shortcut-icon" === b || "apple-touch-icon" === b) && (d.v.config.favicon = c,
                              undefined))
                          },
                          meta: function(a) {
                              var b, c, e, f, g, h;
                              b = d.f.get(a, "content"),
                              c = d.f.get(a, "description"),
                              e = d.f.get(a, "property"),
                              g = d.f.get(a, "http-equiv"),
                              h = d.f.get(a, "content-language"),
                              f = d.f.get(a, "name"),
                              g && h && (undefined,
                              d.f.setLang(h)),
                              b && (f && "pinterest" === f && ("nopin" === b.toLowerCase() && (d.v.data.close = c || d.v.msg.noPinMeta,
                              undefined,
                              undefined),
                              "nohover" === b.toLowerCase() && (d.v.noHoverMeta = !0,
                              undefined,
                              undefined),
                              "pinterest-rich-pin" === f && "false" === b.toLowerCase() && (undefined,
                              undefined)),
                              e && ("og:image" === e && (d.v.meta.og.media = b,
                              undefined),
                              "og:url" === e && (d.v.meta.og.url = b,
                              undefined),
                              "og:description" === e && (d.v.meta.og.description = b,
                              undefined),
                              "og:title" === e && (d.v.meta.og.title = b,
                              undefined),
                              "pin:media" === e && (d.v.meta.pinterest.media = b,
                              undefined),
                              "pin:url" === e && (d.v.meta.pinterest.url = b,
                              undefined),
                              "pin:description" === e && (d.v.meta.pinterest.description = b,
                              undefined),
                              "pin:id" === e && (d.v.meta.pinterest.id = b,
                              undefined)))
                          }
                      },
                      loadImg: function(a) {
                          var b, c;
                          d.v.imgLoadingCount = d.v.imgLoadingCount + 1,
                          b = d.d.createElement("IMG"),
                          b.onerror = function() {
                              d.w.clearTimeout(c),
                              d.v.imgLoadingCount = d.v.imgLoadingCount - 1
                          }
                          ,
                          b.onload = function() {
                              var b, e, f, g, h, i;
                              if (d.w.clearTimeout(c),
                              f = {},
                              undefined,
                              d.v.imgLoadingCount = d.v.imgLoadingCount - 1,
                              f.loaded = !0,
                              i = d.f.getDim(this),
                              f.height = i.h,
                              f.width = i.w,
                              f.media = this.src,
                              a.set)
                                  if ("string" === typeof a.set)
                                      f[a.set] = !0,
                                      d.v.hazSet[a.set] = !0;
                                  else
                                      for (b in a.set)
                                          f[b] = a.set[b],
                                          d.v.hazSet[b] = !0;
                              for (a.url && d.v.canonicalUrl && (a.url !== d.v.canonicalUrl ? (g = d.v.canonicalUrl.split("/")[2],
                              h = a.url.split("/")[2],
                              g === h ? (f.url = a.url,
                              undefined,
                              f.linkOffPage = !0) : (f.url = a.url,
                              f.via = d.v.canonicalUrl,
                              f.linkOffDomain = !0)) : f.isVideo && (f.isCanonical = !0),
                              d.f.kill(this)),
                              a.description && (f.description = a.description),
                              d.v.found.unshift(f),
                              b = 1,
                              e = d.v.found.length; b < e; b += 1)
                                  if (d.v.found[b].media === this.src) {
                                      f.metaOg ? (f.description && (d.v.found[b].description = f.description),
                                      f.url && (d.v.found[b].url = f.url),
                                      d.v.found[b].isCanonical = !0,
                                      d.v.found.shift()) : d.v.found.splice(b, 1);
                                      break
                                  }
                          }
                          ,
                          c = d.w.setTimeout(function() {
                              b = null ,
                              d.v.imgLoadingCount = d.v.imgLoadingCount - 1
                          }, d.a.maxWait),
                          b.src = a.media
                      },
                      handlers: {
                          instagram: function(a) {
                              a && a.thumbnail_url && a.title && a.html && (o = {
                                  media: a.thumbnail_url,
                                  set: {
                                      url: a.html.split('<a href="')[1].split('"')[0],
                                      description: a.title
                                  }
                              },
                              d.f.loadImg(o))
                          }
                      },
                      srcSet: function(a) {
                          var i = d.f.get(a, "srcset");
                          var b, c, e, f, g = '', h = 0;

                          if (i && (b = i.split(","), b.length)) {
                            for (c = 0; c < b.length; c += 1) f = b[c].replace(/^\s+|\s+$/g, "").replace(/\s\s+/g, " ").split(" "), f[1] && (f[1] = f[1].replace(/[^0-9.]/g, "") - 0, h < f[1] && (h = f[1], g = f[0]));
                            g && (e = g.split("#")[0].split("?")[0].split(".").pop(), d.a.validImageFileType[e] && !a.getAttribute("data-pin-media") && (a.setAttribute("data-pin-media", g)))
                          }
                      },
                      modifiers: {
                          page: [function() {
                              var a, b, c;
                              var ddURL = url || d.d.URL;

                              ddURL.match(d.a.pattern.vimeo.page) && (b = d.d.getElementsByTagName("VIDEO")[0],
                              b && (c = b.parentNode.parentNode.getAttribute("data-thumb"),
                              c && (a = {
                                  media: c,
                                  set: {
                                      sourceBump: !0,
                                      url: ddURL,
                                      description: d.d.title
                                  }
                              },
                              d.f.loadImg(a))))
                          }
                          , function() {
                              var a, b, c, e;
                              var ddURL = url || d.d.URL;

                              if (ddURL.match(d.a.pattern.instagram.page))
                                  if (ddURL.match(d.a.pattern.instagram.url))
                                      e = "https://api.instagram.com/oembed?url=" + encodeURIComponent(ddURL),
                                      d.f.call(e, d.f.handlers.instagram);
                                  else
                                      for (a = d.d.getElementsByTagName("A"),
                                      b = 0,
                                      c = a.length; b < c; b += 1)
                                          a[b].href && a[b].href.match(d.a.pattern.instagram.url) && (e = "https://api.instagram.com/oembed?url=" + encodeURIComponent(a[b].href.split("#")[0].split("?")[0]),
                                          d.f.call(e, d.f.handlers.instagram))
                          }
                          , function() {
                              var a, b, c, e, f, g, h;
                              var ddURL = url || d.d.URL;

                              if (ddURL.match(d.a.pattern.amazon.page)) {
                                  var b = d.d.getElementsByTagName("A");
                                  for (c = 0,
                                  e = b.length; c < e; c += 1)
                                      if (b[c].href && b[c].href.match("pinterest.com%2Fpin%2Fcreate%2Fbutton%3F")) {
                                          if (a = b[c].href.split("&token=")[0].split("pinterest.com%2Fpin%2Fcreate%2Fbutton%3F"),
                                          a[1])
                                              try {
                                                  f = decodeURIComponent(a[1]),
                                                  f && (h = d.f.parse("?" + f, {
                                                      url: !0,
                                                      media: !0,
                                                      description: !0
                                                  }),
                                                  h.media && h.url && h.description && (h.url = h.url.split("ref%3D")[0],
                                                  h.description = h.description.split("http")[0],
                                                  g = {
                                                      media: decodeURIComponent(h.media),
                                                      set: {
                                                          sourceBump: !0,
                                                          url: decodeURIComponent(h.url),
                                                          description: decodeURIComponent(h.description)
                                                      }
                                                  },
                                                  d.f.loadImg(g)))
                                              } catch (i) {}
                                          break
                                      }
                              }
                          }
                          , function() {
                              var a, b, c, e, f, g, h, i, j;
                              var ddURL = url || d.d.URL;

                              if (j = function(a) {
                                  var b = {};
                                  b.media = "https://i.ytimg.com/vi/" + a.id + "/hqdefault.jpg",
                                  b.url = "http://www.youtube.com/watch?v=" + a.id,
                                  b.set = {
                                      isVideo: !0,
                                      attrib: "youtube",
                                      url: b.url,
                                      description: d.d.title
                                  },
                                  a.sourceBump && (b.set.sourceBump = !0),
                                  a.sourceOrder && (b.set.sourceOrder = a.sourceOrder),
                                  d.f.loadImg(b)
                              }
                              ,
                              ddURL.match(d.a.pattern.youtube.page))
                                  for (b = ddURL.split("#")[0].split("?v="),
                                  b[1] && j({
                                      id: b[1].split("&")[0],
                                      sourceBump: !0
                                  }),
                                  b = d.d.getElementsByClassName("_mfw"),
                                  c = 0,
                                  e = b.length; c < e; c += 1)
                                      if (f = b[c].currentStyle || d.w.getComputedStyle(b[c], !1),
                                      f && f.backgroundImage && "none" !== f.backgroundImage && (a = f.backgroundImage.split("&")[0].split("="),
                                      a[1])) {
                                          for (g = a[1].split(","),
                                          h = g.length - 1,
                                          i = -1; h > i; h -= 1)
                                              j({
                                                  id: g[h],
                                                  sourceOrder: h
                                              });
                                          break
                                      }
                          }
                          , function() {
                              var a, b, c, e, f, g, h, i, j, k;
                              var ddURL = url || d.d.URL;

                              if (ddURL.match(d.a.pattern.google.page) && (d.v.doNotSort = !0,
                              a = d.d.getElementById("ires")))
                                  for (b = a.getElementsByTagName("A"),
                                  c = 0,
                                  e = b.length; c < e; c += 1)
                                      if (h = "",
                                      media = "",
                                      b[c].href && (g = b[c].href.split("imgrefurl="),
                                      g[1] && (h = g[1].split("&")[0]),
                                      g = b[c].href.split("imgurl="),
                                      g[1] && (media = g[1].split("&")[0])),
                                      h && media && (f = b[c].getElementsByTagName("IMG"),
                                      f[0] && (d.f.set(f[0], "data-pin-url", decodeURIComponent(h)),
                                      d.f.set(f[0], "data-pin-media", decodeURIComponent(media)))),
                                      i = b[c].parentNode.getElementsByTagName("DIV"),
                                      i[2] && (j = i[2].textContent))
                                          try {
                                              k = JSON.parse(j),
                                              "object" === typeof k && (k.s || k.pt) && d.f.set(f[0], "data-pin-description", k.s || k.pt)
                                          } catch (l) {}
                          }
                          , function() {
                              var ddURL = url || d.d.URL;

                              ddURL.match(d.a.pattern.pinterest.page) && window.isMainPinterestSite === !0 && (d.v.data.close = d.v.msg.noPinningFromPinterest)
                          }
                          , function() {
                              var ddURL = url || d.d.URL;

                              ddURL.match(d.a.pattern.facebook.page) && (
                              undefined,
                              d.v.data.close = d.v.msg.noPinDomain.replace(/%noPinDomain%/, "Facebook"))
                          }
                          , function() {
                              var ddURL = url || d.d.URL;

                              ddURL.match(d.a.pattern.craigslist.page) && (d.v.data.close = d.v.msg.noPinDomain.replace(/%noPinDomain%/, "Craigslist"))
                          }
                          ],
                          img: [function(a, b) {
                              var ddURL = url || d.d.URL;

                              if (ddURL.match(d.a.pattern.itunes.page)) {
                                  a.description = d.d.title.split(" on the App Store")[0];
                                  var c = d.d.getElementById("title");
                                  if (c) {
                                      var e = c.getElementsByTagName("H1")
                                        , f = c.getElementsByTagName("H2");
                                      if (e[0] && f[0]) {
                                          var g = e[0].innerHTML
                                            , h = f[0].innerHTML;
                                          g && h && (h = h.charAt(0).toLowerCase() + h.substr(1),
                                          a.description = g + " " + h)
                                      }
                                  }
                              }
                          }
                          , function(a, b) {
                              var c, e;
                              var ddURL = url || d.d.URL;

                              ddURL.match(d.a.pattern.twitter.page) && (c = b.parentNode.parentNode,
                              c && "A" === c.tagName && d.f.get(c, "data-resolved-url-large") && (a.media = d.f.get(c, "data-resolved-url-large"),
                              a.url = c.href,
                              e = c.parentNode.parentNode.parentNode.getElementsByClassName("tweet-text")[0],
                              e && "P" === e.tagName && (a.description = e.innerText)))
                          }
                          , function(a, b) {
                              var c;
                              return c = !1,
                              a.media.match(d.a.pattern.flickr.media) && (a.getsAttribution = !0,
                              a.attrib = "flickr",
                              a.url = d.v.canonicalUrl,
                              c = !0),
                              c
                          }
                          , function(a, b) {
                              var c, e, f;
                              return c = !1,
                              a.media.match(d.a.pattern["500px"].media) && (a.getsAttribution = !0,
                              e = a.media.split("#")[0].split("?")[0].split("/"),
                              f = e.pop(),
                              f.match(/.jpg/) && (a.media = e.join("/") + "/2048.jpg",
                              a.set = {
                                  getsAttribution: !0,
                                  attrib: "fivehundredpx",
                                  url: d.v.canonicalUrl
                              },
                              d.f.loadImg(a),
                              c = !0)),
                              c
                          }
                          , function(a, b) {
                              var c, e;
                              return c = !1,
                              a.media.match(d.a.pattern.youtube.media) && (e = a.media.split("/")[4],
                              a.media = "https://i.ytimg.com/vi/" + e + "/hqdefault.jpg",
                              a.url = d.v.canonicalUrl,
                              a.url.match(d.a.pattern.youtube.page) && (a.url = "https://www.youtube.com/watch?v=" + e),
                              a.set = {
                                  isVideo: !0,
                                  attrib: "youtube",
                                  url: a.url
                              },
                              d.f.loadImg(a),
                              c = !0),
                              c
                          }
                          , function(a, b) {
                              var c, e;
                              return c = !1,
                              a.url || (a.url = d.v.canonicalUrl),
                              e = a["data-pin-url"],
                              e && (delete a["data-pin-url"],
                              a.dataPinUrl = e,
                              a.url = e),
                              e = a["data-pin-id"],
                              e && (delete a["data-pin-id"],
                              a.dataPinId = e),
                              e = a["data-pin-description"],
                              e && (delete a["data-pin-description"],
                              a.dataPinDescription = e),
                              e = a["data-pin-media"],
                              e && (delete a["data-pin-media"],
                              d.f.check.source(e) && (a.media = e,
                              a.set = {
                                  dataPinMedia: !0,
                                  url: a.url
                              },
                              a.dataPinUrl && (a.set.dataPinUrl = a.dataPinUrl),
                              a.dataPinDescription && (a.set.dataPinDescription = a.dataPinDescription),
                              a.dataPinId && (a.set.dataPinId = a.dataPinId),
                              d.f.loadImg(a),
                              c = !0)),
                              c
                          }
                          , function(a, b) {
                              var c, e;
                              var ddURL = url || d.d.URL;

                              return c = !1,
                              e = b.parentNode,
                              "A" === e.tagName && e.href && d.f.check.source(e, !0) && !ddURL.match(d.a.pattern.wikipedia.page) && (a.url || (a.url = d.v.canonicalUrl),
                              a.media = e.href,
                              a.set = {
                                  linkedImg: !0,
                                  url: a.url
                              },
                              d.f.loadImg(a),
                              c = !0),
                              c
                          }
                          ],
                          meta: [function() {
                              var a, b;
                              return a = !1,
                              d.v.meta.pinterest && d.v.meta.pinterest.media && d.f.check.source(d.v.meta.pinterest.media) && (b = {
                                  media: d.v.meta.pinterest.media,
                                  set: {
                                      metaPinterest: !0,
                                      url: d.v.meta.pinterest.url || d.v.canonicalUrl,
                                      description: d.v.meta.pinterest.description || d.d.title || void 0
                                  }
                              },
                              d.v.meta.pinterest.id && (b.set.dataPinId = d.v.meta.pinterest.id),
                              d.f.loadImg(b),
                              a = !0,
                              undefined),
                              a
                          }
                          , function() {
                              var a, b;
                              return d.v.meta.og && d.v.meta.og.media && d.f.check.source(d.v.meta.og.media) && (b = {
                                  media: d.v.meta.og.media,
                                  set: {
                                      metaOg: !0,
                                      url: d.v.meta.og.url || d.v.canonicalUrl,
                                      description: d.v.meta.og.description || d.v.meta.og.title || d.d.title || void 0
                                  }
                              },
                              d.f.loadImg(b),
                              a = !0,
                              undefined),
                              a = !1
                          }
                          ]
                      },
                      runMods: function(a, b, c) {
                          if (d.f.modifiers[a])
                              for (var e = 0; e < d.f.modifiers[a].length && !d.f.modifiers[a][e](b, c); e += 1)
                                  ;
                      },
                      getTags: function() {
                          var a, b, c, e, f, g, h, i, j, k;
                          for (a in d.a.tag)
                              if (b = d.d.getElementsByTagName(a),
                              c = b.length)
                                  for (e = d.a.tag[a],
                                  f = 0; f < c; f += 1) {
                                      for ("img" === a && d.f.srcSet(b[f]),
                                      g = null ,
                                      h = 0; h < e.length; h += 1)
                                          i = d.f.get(b[f], e[h]),
                                          i && (g || (g = {}),
                                          g[e[h]] = i);
                                      g && "function" === typeof d.f.tag[a] && d.f.tag[a](b[f]) && "img" === a && (g.sourceOrder = d.v.sourceOrder,
                                      d.v.sourceOrder = d.v.sourceOrder + 1,
                                      g.src && (g.media = g.src,
                                      delete g.src),
                                      d.f.runMods(a, g, b[f]),
                                      g.description || (j = g.media.split("/").pop(),
                                      k = j.split(".")[0],
                                      (g.title === j || g.title === k) && (g.title = null ),
                                      (g.alt === j || g.alt === k) && (g.alt = null ),
                                      g.description = g.title || g.alt || d.v.meta.pinterest.description || d.v.meta.og.description || d.v.meta.og.title || d.v.title || void 0),
                                      d.v.found.push(g))
                                  }
                      },
                      arrange: function() {
                          var a, b, c, e, f, g;
                          for (a = 0,
                          b = d.v.found.length; a < b; a += 1)
                              g = 0,
                              c = d.v.found[a],
                              c.dataPinDescription && (c.description = c.dataPinDescription),
                              !c.description && (c.description = defaultTitle),
                              c.description = c.description.substring(0, 497),
                              497 === c.description.length && (c.description = c.description + "..."),
                              "number" === typeof c.naturalHeight && c.naturalHeight && (c.height = c.naturalHeight,
                              delete c.naturalHeight),
                              "number" === typeof c.naturalWidth && c.naturalWidth && (c.width = c.naturalWidth,
                              delete c.naturalWidth),
                              e = parseInt(c.height),
                              f = parseInt(c.width),
                              f > e && (f = e),
                              e > 3 * f && (e = 3 * f),
                              g = e * f,
                              c.isCanonical && (g = 3 * g),
                              (c.dataPinId || c.pinItButton || c.dataPinMedia || c.dataPinUrl || c.metaPinterest) && (g = 3 * g),
                              c.isVideo && (g = 3 * g),
                              c.sourceBump && (g = 3 * g),
                              f < d.a.thumbCellSize && (g /= 2,
                              d.v.hazSet.sourceBump && (g /= 10)),
                              c.metaOg && b > 1 && f < d.a.thumbCellSize && (g /= 100),
                              //c.usemap && (g /= 100),
                              c.sourceOrder && (g -= 100 * c.sourceOrder),
                              c.order = g;
                          if (d.v.found.length && !d.v.doNotSort) {
                              var h = function(a, b) {
                                  return b.order - a.order
                              }
                              ;
                              for (d.v.found.sort(h),
                              g = d.v.found[0].order,
                              a = 1,
                              b = d.v.found.length; a < b; a += 1)
                                  if (d.v.found[a].order < g / d.v.config.quality) {
                                      d.v.found[a].halt = !0;
                                      break
                                  }
                          }
                      },
                      log: function(a) {
                      },
                      done: function() {
                          var a, b;
                          if (undefined,
                          d.v.data.close)
                              d.v.config.quiet || d.w.alert(d.v.data.close);
                          else {
                              for (d.f.arrange(),
                              d.v.data.thumb = d.v.found,
                              a = 0,
                              b = d.v.data.thumb.length; a < b; a += 1)
                                  d.v.data.thumb[a].src = d.v.data.thumb[a].media,
                                  d.v.data.thumb[a].isVideo && (d.v.data.thumb[a].multimedia = !0);
                              if (d.v.config.share)
                                  return undefined,
                                  d.d.b.setAttribute(d.v.config.share, JSON.stringify(d.v.data)),
                                  void (d.v.data.thumb.length || d.v.config.quiet || d.w.alert(d.v.msg.noPinnablesFound));
                              if (d.w[d.v.config.render] && "function" === typeof d.w[d.v.config.render])
                                  return undefined,
                                  void d.w[d.v.config.render](d.v.data);
                              d.v.defaultBodyOverflow = "",
                              "function" === typeof d.w.getComputedStyle && "function" === d.w.getComputedStyle(d.d.b).getPropertyValue && (d.v.defaultBodyOverflow = d.w.getComputedStyle(d.d.b).getPropertyValue("overflow")),
                              "visible" === d.v.defaultBodyOverflow && (d.v.defaultBodyOverflow = ""),
                              d.d.b.style.overflow = "hidden",
                              undefined,
                              d.v.data.config = d.v.config,
                              // Disable nag screen so we don't need nag variables
                              d.v.data.hazExtension = true; //d.f.get(d.d.b, "data-pinterest-extension-installed");
                              var c = JSON.stringify(d.v.data);
                              d.s.dark = d.f.make({
                                  IFRAME: {
                                      id: d.a.k + "_grid",
                                      // Disabled the cache busting timestamp
                                      // Disabled it all so we can inject HTML later
                                      //src: d.a.grid, // + "?" + (new Date).getTime(),
                                      src: d.a.grid,
                                      frameBorder: "0",
                                      style: {
                                          display: "block",
                                          position: "fixed",
                                          height: "100%",
                                          width: "100%",
                                          top: "0",
                                          left: "0",
                                          bottom: "0",
                                          right: "0",
                                          margin: "0",
                                          clip: "auto",
                                          "z-index": "9223372036854775807"
                                      }
                                  }
                              });
                              var e = function() {
                                  d.d.b.style.overflow = d.v.defaultBodyOverflow,
                                  d.d.b.removeAttribute(d.a.hazPinningNow),
                                  d.f.kill(d.s.dark)
                              }
                                , f = (new Date).getTime();
                              d.s.dark.onload = function() {
                                  var a = (new Date).getTime() - f;
                                  undefined,
                                  undefined,
                                  d.v.receiver = d.s.dark.contentWindow,
                                  d.v.receiver.postMessage(c, d.s.dark.src),
                                  d.f.listen(d.w, "message", function(a) {
                                      d.w.clearTimeout(d.v.renderFailed),
                                      "x" === a.data && e()

                                      // Handle our callback
                                      try {
                                        var message = JSON.parse(a.data);

                                        if (
                                          'object' === typeof message
                                          && 'undefined' !== typeof message['type']
                                          && 'undefined' !== typeof message['url']
                                          && 'undefined' !== typeof message['name']
                                          && 'undefined' !== typeof message['specs']
                                          && 'sumomeShareCallback' == message.type
                                        ) {
                                          var win = d.w.open(message.url, message.name, message.specs);

                                          if (cb) {
                                            var winClosedChecks = 0;
                                            var winBlocked = ('object' !== typeof win || win === null);
                                            var timer = setInterval(function() {
                                              if (
                                                winBlocked || win.closed
                                                || winClosedChecks++ > 120
                                              ) {
                                                if (winBlocked) {
                                                  alert('Please disable your popup blocker');
                                                }
                                                clearInterval(timer);
                                                console.log('[jquery.share] firing callback...');
                                                cb();
                                              }
                                            }, 500);
                                          }
                                        }
                                      } catch (jsonParseError) {
                                        // Wasn't JSON... keep movin'...
                                      }
                                  }),
                                  this.focus()
                              }
                              ,
                              d.f.set(d.d.b, d.a.hazPinningNow, "true"),
                              d.d.b.appendChild(d.s.dark),

                              d.v.renderFailed = d.w.setTimeout(function() {
                                  console.log('[jquery.share] rendering failed...');
                                  undefined,
                                  d.w.alert(d.v.msg.noPinnablesFound),
                                  e()
                              }, d.a.maxWait)
                          }
                      },
                      setLang: function(a) {
                          a && ("object" === typeof d.a.msg[a] ? (undefined,
                          d.v.msg = d.a.msg[a],
                          d.v.data.msg = d.v.msg) : (a = a.split("-")[0],
                          "object" === typeof d.a.msg[a] ? (undefined,
                          d.v.msg = d.a.msg[a],
                          d.v.data.msg = d.v.msg) : (undefined,
                          d.v.msg = d.a.msg.en,
                          d.v.data.msg = d.v.msg)))
                      },
                      getLang: function() {
                          var a;
                          a = d.d.getElementsByTagName("HTML")[0].getAttribute("lang") || "en",
                          a && (a = a.toLowerCase(),
                          d.f.setLang(a))
                      },
                      init: function() {
                          var a;
                          var ddURL = url || d.d.URL;

                          var titleTags = d.d.getElementsByTagName('TITLE');

                          for (var i = 0; i < titleTags.length; i++) {
                            if (!defaultTitle) {
                              defaultTitle = titleTags[i].textContent;
                            }
                          }

                          d.d.b = d.d.getElementsByTagName("BODY")[0],
                          d.d.b && (d.w.getComputedStyle || (d.w.getComputedStyle = function() {
                              return !1
                          }
                          ),
                          d.f.get(d.d.b, d.a.hazPinningNow) || (d.d.d = d.d.documentElement,
                          d.d.h = d.d.getElementsByTagName("HEAD")[0],
                          d.v = {
                              sourceOrder: 0,
                              canonicalUrl: ddURL,
                              src: {},
                              config: {
                                  pinMethod: "bookmarklet",
                                  quality: d.a.quality,
                                  favicon: d.w.location.protocol + "//" + ddURL.split("/")[2] + "/favicon.ico",
                                  xv: d.d.b.getAttribute(d.a.xv)
                              },
                              hazSet: {},
                              meta: {
                                  og: {},
                                  pinterest: {}
                              },
                              imgLoadingCount: 0,
                              callbackLoadingCount: 0,
                              srcDomain: {},
                              extensionVer: d.f.get(d.d.b, "data-pinterest-extension-installed") || void 0,
                              msg: d.a.msg.en,
                              css: "",
                              data: {
                                  blacklistedSource: {},
                                  thumb: []
                              },
                              found: []
                          },
                          d.f.getLang(),
                          d.f.getConfig(),
                          d.v.data.url = ddURL,
                          d.v.config.pinbox && (d.v.data.pinbox = d.v.config.pinbox),
                          d.f.check.domain(ddURL) ? (d.f.runMods("page"),
                          d.f.getTags(),
                          d.f.runMods("meta"),
                          d.v.safety = d.w.setTimeout(function() {
                              d.v.check && d.w.clearTimeout(d.v.check),
                              d.f.done()
                          }, d.a.maxWait),
                          (a = function() {
                              d.v.imgLoadingCount > 0 || d.v.callbackLoadingCount > 0 ? d.v.check = d.w.setTimeout(a, 100) : (d.v.safety && d.w.clearTimeout(d.v.safety),
                              d.f.done())
                          }
                          )()) : (d.v.data.close = d.v.msg.noPinDomain,
                          d.f.done())))
                      }
                  }
              }()
          };
          d.f.init();
        }

        selectPinImage(cb, url, null, null, true);
      },
      priority: 97,
    },
    plurk: {
      name: 'Plurk',
      url: 'http://www.plurk.com/m?content={URL}&qualifier=shares',
      width: 600,
      height: 500,
      background: '#CF682E',
      color: '#fff',
    },
    pocket: {
      name: 'Pocket',
      url: 'https://getpocket.com/save?url={URL}&title={TEXT}',
      width: 520,
      height: 315,
      background: '#EE4056',
      color: '#fff'
    },
    /*
    print: {
      name: 'Print',
      background: '#999',
      foreground: '#fff',
      javascript: function() {
        window.print();
      },
    },
    */
    printfriendly: {
      name: 'PrintFriendly.com',
      background: '#9ec36e',
      foreground: '#fff',
      javascript: function() {
        if(window['priFri']){
          window.print()
        }else{
          var pfurl='';
          pfstyle='nbk';
          pfBkVersion='1';

          if(window.location.href.match(/https/)){
            pfurl='https://pf-cdn.printfriendly.com/ssl/main.js'
          }else{
            pfurl='http://cdn.printfriendly.com/printfriendly.js'
          }

          _pnicer_script=document.createElement('SCRIPT');
          _pnicer_script.type='text/javascript';
          _pnicer_script.src=pfurl + '?x='+(Math.random());
          document.getElementsByTagName('head')[0].appendChild(_pnicer_script);
        }
      },
    },
    printerfriendly: {
      name: 'Printer Friendly',
      background: '#999',
      foreground: '#fff',
      javascript: function() {
        $(document).printPreview();
      }
    },
    reddit: {
      name: 'Reddit',
      url: 'http://reddit.com/submit?url={URL}&title={TEXT}',
      width: 860,
      height: 500,
      background: '#ff5700',
      color: '#fff',
      method: 'json',
      fetch: '//reddit.com/button_info.json?url={URL}',
      parse: function(data) {
        if ('data' in data && 'children' in data.data && data.data.children.length > 0)
          return parseInt(data.data.children[0].data.score);
        return 0;
      },
      priority: 92,
    },
    /*share: {
      name: 'Share',
      url: '',
      width: 600,
      height: 500,
      background: '#fff',
      color: '#000'
    },*/
    slashdot: {
      name: 'Slashdot',
      width: 600,
      height: 500,
      background: '#1A5C59',
      color: '#fff',
      javascript: function() {
        var b=document.body;
        if(b&&!document.xmlVersion){
          void(z=document.createElement('script'));
          void(z.src='https://images.slashdot.org/slashdot-submission.ssl.js');
          void(b.appendChild(z));
        }else{}
      },
    },
    sms: {
      name: 'SMS',
      url: 'sms:?body={TEXT}%0A%0D{URL}',
      width: 600,
      height: 500,
      background: '#0076ff',
      color: '#fff',
      priority: 93,
    },
    soupio: {
      name: 'Soup',
      url: '',
      width: 450,
      height: 400,
      background: '#C80813',
      color: '#fff',
      javascript: function() {
        var es=['body','frameset','head'];
        var u=document.location.protocol+'//www.soup.io/';
        var fn='soup_bookmarklet_'+(Math.floor(Math.random()*100000));

        window.open(u+'bookmarklet-loading.html',fn,'toolbar=0,resizable=1,scrollbars=yes,status=1,width=450,height=400');
        try {
          var s=document.createElement('script');
          s.setAttribute('src',u+'bookmarklet/js/'+fn+'/5');
          for (var i=0;i<es.length;i  ){
            var e=document.getElementsByTagName(es[i])[0];
            if(e){
              e.appendChild(s);
              break;
            }
          }
        } catch(e) {
          //alert("This doesn't work here.");
        }
      },
    },
    sumome: {
      name: 'SumoMe',
      url: '',
      width: 600,
      height: 500,
      background: '#0f52ba',
      color: '#fff'
    },
    tapiture: {
      name: 'Tapiture',
      url: 'http://tapiture.com/widget/tap?url={IMAGE}&title={TEXT}&page_url={URL}&type=image&description=&alt={DESC}&img_title=&img_width=&img_height=',
      width: 600,
      height: 500,
      background: '#325892',
      color: '#fff',
    },
    techmeme: {
      name: 'Techmeme',
      filterText: function(text) {
        var truncate = function(str, limit) {
          var chars, i;
          chars = str.split('');
          if (chars.length > limit) {
            for (i = chars.length - 1; i > -1; --i) {
              if (i > limit) {
                chars.length = i;
              }
              else if (' ' === chars[i]) {
                chars.length = i;
                break;
              }
            }
            chars.push('...');
          }
          return chars.join('');
        };
        return truncate(text, 117);
      },
      url: 'https://twitter.com/intent/tweet?url={URL}&text=tip+@techmeme:+{TEXT}',
      width: 600,
      height: 445,
      background: '#1E4B62',
      color: '#fff',
    },
    tinyurl: {
      name: 'TinyURL',
      url: 'http://tinyurl.com/create.php?url={URL}',
      width: 800,
      height: 660,
      background: '#009',
      color: '#fff',
    },
    tumblr: {
      name: 'Tumblr',
      url: 'http://www.tumblr.com/share?v=3&u={URL}&t={TEXT}',
      width: 450,
      height: 450,
      background: '#2c4762',
      color: '#fff',
      priority: 88,
    },
    twitter: {
      name: 'X',
      filterText: function(text) {
        var truncate = function(str, limit) {
          var chars, i;
          chars = str.split('');
          if (chars.length > limit) {
            for (i = chars.length - 1; i > -1; --i) {
              if (i > limit) {
                chars.length = i;
              }
              else if (' ' === chars[i]) {
                chars.length = i;
                break;
              }
            }
            chars.push('…');
          }
          return chars.join('');
        };
        return truncate(text, 117);
      },
      url: 'https://twitter.com/intent/tweet?url={URL}&text={TEXT}&via={VIA}&related={RELATED}',
      width: 600,
      height: 445,
      background: '#000',
      color: '#fff',
      params: {
        'via': {
          label: 'X @username',
          desc: 'X screen name to append to posts with the via attribute. Do not include @ symbol.'
        },
        'related': {
          label: 'Suggested accounts',
          desc: 'Comma separated list of X accounts to suggest following. Do not include @ symbol or spaces.'
        }
      },
      //fetch: 'https://cdn.api.twitter.com/1/urls/count.json?url={URL}',
      //parse: function(data) {
      //  return parseInt(data.count);
      //},
      priority: 98,
    },
    typepadpost: {
      name: 'Typepad',
      url: 'http://www.typepad.com/services/quickpost/post?v=2&qp_show=ac&qp_title={TEXT}&qp_href={URL}&qp_text={DESC}',
      width: 585,
      height: 735,
      background: '#7A9B5D',
      color: '#fff',
    },
    viadeo: {
      name: 'Viadeo',
      url: 'http://www.viadeo.com/shareit/share/?url={URL}',
      width: 600,
      height: 600,
      background: '#E46123',
      color: '#fff',
    },
    vk: {
      name: 'VKontakte',
      url: 'http://vk.com/share.php?url={URL}&title={TEXT}',
      width: 660,
      height: 500,
      background: '#4D76A1',
      color: '#fff',
      //fetch: '//vk.com/share.php?act=count&url={URL}',
      //method: 'jsonproxy',
      //parse: function(data) {
      //  return parseInt(data.data.match(/^VK\.Share\.count\(\d, (\d+)\);$/)[1]);
      //}
    },
    wanelo: {
      name: 'Wanelo',
      width: 600,
      height: 500,
      background: '#518653',
      color: '#fff',
      javascript: function() {
        if(!window.waneloBookmarklet){
          var productURL=encodeURIComponent(location.href),
            cacheBuster=Math.floor(Math.random()*1e3),
            element=document.createElement('script');

          element.setAttribute('src','//wanelo.com/bookmarklet/3/setup?*='+cacheBuster+'&url='+productURL),
          element.onload=init,element.setAttribute('type','text/javascript'),

          document.getElementsByTagName('head')[0].appendChild(element)
        }else
          init();

        function init(){
          window.waneloBookmarklet()
        }
      },
    },
    weheartit: {
      name: 'We Heart It',
      url: 'http://weheartit.com/heart-it/new_entry?encoding=utf-8&popup=1&hearting_method=heart_it_button&image_url={IMAGE}&source_url={URL}',
      width: 700,
      height: 500,
      background: '#FD6B9C',
      color: '#fff',
    },
    whatsapp: {
      name: 'WhatsApp',
      url: 'whatsapp://send?text={TEXT}%20{URL}',
      width: 600,
      height: 500,
      background: '#1d9e11',
      color: '#fff',
      priority: 94,
    },
    wordpressblog: {
      name: 'Wordpress Blog',
      url: 'https://sumome.com/apps/share/wordpress?u={URL}&t={TEXT}&s={DESC}&i={IMAGE}',
      width: 600,
      height: 350,
      background: '#000',
      color: '#fff',
    },
    wykop: {
      name: 'Wykop',
      url: 'http://www.wykop.pl/dodaj/link/?url={URL}&title={TEXT}&desc={DESC}',
      width: 600,
      height: 500,
      background: '#4684AD',
      color: '#fff',
    },
    xing: {
      name: 'XING',
      url: 'https://www.xing.com/spi/shares/new?url={URL}',
      width: 600,
      height: 600,
      background: '#006567',
      color: '#fff',
    },
    yahoomail: {
      name: 'Yahoo! Mail',
      url: 'http://compose.mail.yahoo.com/?subject={TEXT}&body={URL}',
      width: 1160,
      height: 690,
      background: '#2E147B',
      color: '#fff',
    },
    // Doesn't seem like the ymsgr: protocol is still supported. Doesn't work
    // as expected in Adium nor the official Yahoo! Messenger Android client.
    // yahoomessenger: {
    //   name: 'Yahoo! Messenger',
    //   url: 'ymsgr:im?+&msg={TEXT}%20{URL}',
    //   width: 600,
    //   height: 500,
    //   background: '#2E147B',
    //   color: '#fff',
    // },
    yammer: {
      name: 'Yammer',
      url: 'https://www.yammer.com/messages/new?login=true&trk_event=yammer_share&status={TEXT} {URL}',
      width: 600,
      height: 350,
      background: '#1074C3',
      color: '#fff',
    },
    ychackernews: {
      name: 'YC Hacker News',
      url: 'https://news.ycombinator.com/submitlink?u={URL}&t={TEXT}',
      width: 600,
      height: 335,
      background: '#FC6620',
      color: '#fff',
    },
    yummly: {
      name: 'Yummly',
      url: 'http://www.yummly.com/urb/verify?url={URL}&title={TEXT}&image={IMAGE}',
      width: 600,
      height: 500,
      background: '#e0601f',
      color: '#fff',
      fetch: '//www.yummly.com/services/yum-count?url={URL}',
      parse: function(data) {
        if ('count' in data)
          return parseInt(data.count);
        if ('error' in data)
          throw new Error(data.error);
        return 0;
      },
      priority: 87,
    }
  };

  $.shareSortedKeys = Object.keys($.shareServices);

  var sortServices = function(a, b) {
    var i = 'priority' in $.shareServices[a] ? $.shareServices[a].priority : 0;
    var j = 'priority' in $.shareServices[b] ? $.shareServices[b].priority : 0;
    var delta = j - i;
    if (delta == 0)
      return a < b ? -1 : 1;
    return delta;
  };

  $.shareSortedKeys.sort(sortServices);

  $.shareShortUrls = {};

  $.share = function(service, data, cb) {
    var url = data.url || window.location.href.split("#")[0];
    var text = data.text || $('meta[property="og:title"]').eq(0).attr('content') || $('title').eq(0).text() || document.title;
    var cb = cb || null;
    var image = $('meta[property="og:image"]').eq(0).attr('content') || $('link[rel="image_src"]').eq(0).attr('href') || '';
    var noSumoBranding = data.noSumoBranding;

    // Twitter cards if ya got 'em
    if (service === 'twitter' && $('meta[name="twitter:image"]').length) {
      image = $('meta[name="twitter:image"]').eq(0).attr('content');
    }

    if (image == '') {
      var bestSize = 0;
      var bestImg = null;
      $('img').each(function() {
        var w = $(this).width();
        var h = $(this).height();
        var r = 1;

        if (w && h) {
          if (w >= h) {
            r = h / w;
          } else {
            r = w / h;
          }
          var size = w * h * r;

          if (size > bestSize) {
            bestSize = size;
            bestImg = $(this);
          }
        }
      });
      if (bestImg != null) {
        image = bestImg.get(0).src || '';
      }
    }

    var service = service.toLowerCase();
    if (service in $.shareServices) {
      if ('javascript' in $.shareServices[service]) {
        if ('shortenUrl' in data && 'shortener' in data && data.shortenUrl && service != 'pinterest') {
            var urlKey = data.shortener + ':' + url;
            if (urlKey in $.shareShortUrls) {
              console.log('using cached url...');
              url = $.shareShortUrls[urlKey];
              $.shareServices[service].javascript(url, text, null, image, function() {
                if (cb)
                  cb(service, url);
              });
            } else {
              console.log('shortening url...');
              $.ajax({
                type: 'POST',
                dataType: 'json',
                url: data.sumoUrl + '/apps/share/shorten',
                data: {
                  site_id: data.siteId,
                  href: url,
                },
                xhrFields: {
                  withCredentials: false,
                },
                crossDomain: true,
              }).done(function(shortenerData) {
                if ('success' in shortenerData && shortenerData.success) {
                  $.shareShortUrls[urlKey] = shortenerData.url;
                  url = shortenerData.url;
                  $.extend(data, shortenerData);
                }
                $.shareServices[service].javascript(url, text, null, image, function() {
                  if (cb)
                    cb(service, url);
                });
              });
            }
        } else {
          // Grabs the pinterest messages
          if ('pinterest' === service) {
            var language = (document.getElementsByTagName("HTML")[0].getAttribute("lang") || "en").toLowerCase();
            var msg = {};

            $.ajax({
              type: 'POST',
              dataType: 'json',
              url: data.sumoUrl + '/apps/share/pinterest/messages',
              data: {
                site_id: data.siteId,
                language: language,
              },
              xhrFields: {
                withCredentials: false,
              },
              crossDomain: true,
            }).done(function(msgData) {
              if (
                'undefined' !== typeof msgData['success']
                && msgData.success
                && 'undefined' !== typeof msgData['messages']
              ) {
                msg[language] = msgData.messages;
              } else {
                msg[language] = {
                  noPinDomain: "Sorry, pinning is not allowed from this domain. Please contact the site operator if you have any questions.",
                  noPinMeta: "Sorry, pinning is not allowed from this page. Please contact the site operator if you have any questions.",
                  noPinnablesFound: "Sorry, couldn't find any pinnable things on this page.",
                  noPinningFromPinterest: "Oops! That button doesn't work on Pinterest. Try using the red Pin It button at the top of any Pin.",
                  choosePin: "Choose a Pin to save",
                };
              }

              $.shareServices[service].javascript(data.sumoUrl, msg, url, text, null, image, function() {
                if (cb)
                  cb(service, url);
              });
            });
          } else {
            $.shareServices[service].javascript(url, text, null, image, function() {
              if (cb)
                cb(service, url);
            });
          }
        }
      } else {
        var shareUrl = $.shareServices[service].url;
        var width = $.shareServices[service].width;
        var height = $.shareServices[service].height;
        var win = 'sumomeShare-' + (Math.random() * 0x100000000);
        if (shareUrl) {
          var skipShortener = [
            'pinterest',
            'reddit',
            'yummly',
          ];
          if ('shortenUrl' in data && 'shortener' in data && data.shortenUrl && skipShortener.indexOf(service) < 0) {
            var urlKey = data.shortener + ':' + url;
            if (urlKey in $.shareShortUrls) {
              console.log('using cached url...');
              url = $.shareShortUrls[urlKey];
              $.shareWindow(service, data, shareUrl, text, url, image, noSumoBranding, win, cb);
            } else {
              console.log('shortening url...');
              if (shareUrl.toLowerCase().substring(0, 4) == 'http')
                window.open(service == 'facebook' ? '' : data.sumoUrl + '/apps/share/loading', win, 'height=' + height + ',width=' + width + ',location=0,menubar=0,status=0,titlebar=0,toolbar=0');

              $.ajax({
                type: 'POST',
                dataType: 'json',
                url: data.sumoUrl + '/apps/share/shorten',
                data: {
                  site_id: data.siteId,
                  href: url,
                },
                xhrFields: {
                  withCredentials: false,
                },
                crossDomain: true,
              }).done(function(shortenerData) {
                if ('success' in shortenerData && shortenerData.success) {
                  $.shareShortUrls[urlKey] = shortenerData.url;
                  url = shortenerData.url;
                  $.extend(data, shortenerData);
                }
                $.shareWindow(service, data, shareUrl, text, url, image, noSumoBranding, win, cb);
              });
            }
          } else {
            console.log('using full url...');
            $.shareWindow(service, data, shareUrl, text, url, image, noSumoBranding, win, cb);
          }
        }
      }
    }
  };

  $.shareWindow = function(service, data, shareUrl, text, url, image, noSumoBranding, winName, cb) {
    if ('filterText' in $.shareServices[service])
      text = $.shareServices[service].filterText(text);
    shareUrl = shareUrl.replace(/{URL}/g, encodeURIComponent(url));
    shareUrl = shareUrl.replace('{TEXT}', encodeURIComponent(text));
    shareUrl = shareUrl.replace('{DESC}', '');
    shareUrl = shareUrl.replace('{IMAGE}', encodeURIComponent(image));
    shareUrl = shareUrl.replace(
      '{PROMO}',
      noSumoBranding
        ? ''
        : '%0A%0A%0AShared%20by%20Sumo%20%28%20http%3A%2F%2Fsumome.com%2F%20%29'
    );

    if ('params' in $.shareServices[service]) {
      for (var k in $.shareServices[service]['params']) {
        if (k in data && data[k]) {
          shareUrl = shareUrl.replace('{' + k.toUpperCase() + '}', encodeURIComponent(data[k]));
        } else {
          // Use Twitter card meta if service variable isn't available
          if (
            service === 'twitter' && (k === 'via' || k === 'related') && (
              $('meta[name="twitter:site"]').length
              || $('meta[name="twitter:creator"]').length
            )
          ) {
            var twitterSite = ($('meta[name="twitter:site"]').eq(0).attr('content') || '');
            var twitterCreator = ($('meta[name="twitter:creator"]').eq(0).attr('content') || '');
            var useBothTwitterUsernames = (twitterSite && twitterCreator && (twitterSite !== twitterCreator));
            var username;

            if (twitterSite.substr(0, 1) === '@') twitterSite = twitterSite.substr(1);
            if (twitterCreator.substr(0, 1) === '@') twitterCreator = twitterCreator.substr(1);

            if (k === 'via') {
              if (useBothTwitterUsernames) {
                // Twitter lets you hack in multiple users with spaces, second
                // username needs the @ symbol though
                username = twitterSite + ' @' + twitterCreator;
              } else {
                username = (twitterSite || twitterCreator);
              }
            } else {
              if (useBothTwitterUsernames) {
                // Related param accepts a comma separated list
                username = twitterSite + ',' + twitterCreator;
              } else {
                username = (twitterCreator || twitterSite);
              }
            }

            shareUrl = shareUrl.replace(
              '{' + k.toUpperCase() + '}',
              encodeURIComponent(username)
            );
          } else {
            shareUrl = shareUrl.replace('&' + k + '={' + k.toUpperCase() + '}', '');
          }
        }
      }
    }

    if (shareUrl.toLowerCase().substring(0, 5) == 'sms:?') {
      if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
        shareUrl = shareUrl.replace(/sms:(\+?([0-9]*))?\?/, 'sms:$1&');
      }
    }

    if (shareUrl.toLowerCase().substring(0, 4) != 'http') {
      console.log('not http...');
      var a = document.createElement('a');
      a.href = shareUrl;
      document.body.appendChild(a);
      if ('FastClick' in window && window.FastClick){
        window.location.href = shareUrl;
      } else if(a.click) {
        a.click();
      } else if(document.createEvent) {
        var eventObj = document.createEvent('MouseEvents');
        eventObj.initMouseEvent('click',true,true, window);
        a.dispatchEvent(eventObj);
      }
      document.body.removeChild(a);
      if (cb)
        cb(service, url);
    } else {
      console.log('creating window...', winName);
      var width = $.shareServices[service].width;
      var height = $.shareServices[service].height;
      var win = window.open(shareUrl, winName, 'height=' + height + ',width=' + width + ',location=0,menubar=0,status=0,titlebar=0,toolbar=0');

      if (cb) {
        var winClosedChecks = 0;
        var timer = setInterval(function() {
          if (win.closed || winClosedChecks++ > 120) {
            clearInterval(timer);
            cb(service, url);
          }
        }, 500);
      }
    }
  };

  $.shareFetch = function(service, url, cb) {
    var cb = cb || null;
    var url = url || window.location.href.split("#")[0];
    if (typeof url == 'function') {
      cb = url;
      url = window.location.href.split("#")[0];
    }
    var service = service.toLowerCase();
    if (service in $.shareServices && 'fetch' in $.shareServices[service] && 'parse' in $.shareServices[service]) {
      try {
        var method = 'jsonp';

        if ('method' in $.shareServices[service])
          method = $.shareServices[service].method;

        if (method == 'json') {
          $.ajax({
            type: 'GET',
            url: $.shareServices[service].fetch.replace('{URL}', encodeURIComponent(url)),
            jsonp: 'jsonp',
            dataType: 'jsonp',
            cache: false,
            success: function(json) {
              //console.log('json:', json);
              try {
                var res = $.shareServices[service].parse(json);
                if (cb !== null)
                  cb(null, url, res);
              } catch (e) {
                if (cb !== null)
                  cb(e);
              }
            },
            error: function(e) {
              console.log(e.message);
              if (cb !== null)
                cb(e);
            }
          });
        } else if (method == 'jsonproxy') {
          return cb(null, url, 0);
        } else if (method == 'jsonp') {
          $.ajax({
            type: 'GET',
            url: $.shareServices[service].fetch.replace('{URL}', encodeURIComponent(url)),
            contentType: 'application/json',
            dataType: 'jsonp',
            cache: false,
            success: function(json) {
              //console.log('json:', json);
              try {
                var res = $.shareServices[service].parse(json);
                if (cb !== null)
                  cb(null, url, res);
              } catch (e) {
                if (cb !== null)
                  cb(e);
              }
            },
            error: function(e) {
              console.log(e.message);
              if (cb !== null)
                cb(e);
            }
          });
        } else if (method == 'linkedin') {
          var jsonpCallback = 'linkedinjsonpcallback'

          for (var i = 0; i < 6; i++) {
            jsonpCallback += String.fromCharCode(Math.floor(Math.random() * 26) + 97);
          }

          $.ajax({
            type: 'GET',
            url: $.shareServices[service].fetch.replace('{URL}', encodeURIComponent(url)),
            contentType: 'application/json',
            dataType: 'jsonp',
            jsonpCallback: jsonpCallback,
            cache: false,
            success: function(json) {
              //console.log('json:', json);
              try {
                var res = $.shareServices[service].parse(json);
                if (cb !== null)
                  cb(null, url, res);
              } catch (e) {
                if (cb !== null)
                  cb(e);
              }
            },
            error: function(e) {
              console.log(e.message);
              if (cb !== null)
                cb(e);
            }
          });
        }
      } catch (e) {
        console.log(e.message);
        if (cb !== null)
          cb(e);
      }
    } else {
      if (cb !== null)
        cb(new Error('Invalid service'));
    }
  };

  return {
    services: $.shareServices,
    sortedKeys: $.shareSortedKeys,
  };
});
